import {
    IonPage, IonContent, IonInput, IonTitle
} from '@ionic/react';
import React, {Component} from "react";
import './css/style.css';
import {withRouter} from "react-router-dom";
import {logQuery} from "./Service";
import cookieUtil from "../../../../utils/cookieUtil";


class RechargeRecord extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showTipModal: false,
            getCodeMsg: "获取验证码",
            recordList: [],
            token: null,
        }
    }

    componentDidMount() {
        if (cookieUtil.has("access_token")) {
            this.setState({token: cookieUtil.get("access_token")})
            this.queryRechargeRecord();
        }

    }

    queryRechargeRecord = () => {
        const {token} = this.state;
        if (cookieUtil.has("access_token")) {
            const params = {
                'access_token': cookieUtil.get("access_token"),
                'queryType': 1,
                'pageIndex': 1,
                'pageSize': 50,
            };
            //console.log(params)
            logQuery(params).then(ret => {
                if (ret.code === '10000') {
                    this.setState({
                        recordList: ret.data.payLogList,
                    })
                } else {
                    this.setState({
                        isShowTip: true,
                        showTipMsg: ret.msg
                    })
                }
            }).catch(err => {
                console.log(err);
            });
        }
    }

    render() {

        const {recordList} = this.state;

        return (
            <IonPage>
                <IonContent fullscreen>
                    <div className="sut_cont bggray">
                        <div className={"phone_top pr border-bottom-e6"}>
                            <div className="top_title">充值记录</div>
                        </div>
                        <div className="cont_kf">
                            <div className="record pt10">
                                {recordList.map((item, index) => {
                                    return (
                                        <div key={index} className="record_list">
                                                <p><span>充值方式</span><em>{item.payTypeName}</em></p>
                                                <p><span>充值金额</span><em className="textBlack fs38">{item.money}</em></p>
                                                <p><span>商品名称</span><em className="textRed">{item.getSome}</em></p>
                                                <p><span>充值时间</span><em className="textGrey9">{item.payTime}</em></p>
                                           </div>
                                    )
                                })}
                                <p className="textGrey6 pt30 pl30">(只显示最近3天记录)</p>
                            </div>
                        </div>
                    </div>
                </IonContent>
            </IonPage>
        );
    }
}

export default withRouter(RechargeRecord);
